'use server';

import { SessionService } from '@/contexts/authentication/services/SessionService';

export interface CurrentUserData {
  id: string;
  email: string | null;
  name: string | null;
  image: string | null;
  role: string;
  familyId: string | null;
  familyName: string | null;
  memberId: string | null;
  provider: string | null;
}

export async function getCurrentUser(): Promise<CurrentUserData | null> {
  const session = await SessionService.getSession();
  if (!session?.user?.id) return null;

  const user = session.user;
  return {
    id: user.id,
    email: user.email ?? null,
    name: user.name ?? null,
    image: user.image ?? null,
    role: user.role ?? 'user',
    familyId: user.familyId ?? null,
    familyName: user.familyName ?? null,
    memberId: user.id, // In OwlCat, user.id is the memberId
    provider: null, // Can be extended to fetch from accounts
  };
}
